import { Info } from 'lucide-react'

/**
 * Read-only info-box -- treść w {@code helpText}, opcjonalny tytuł w {@code labelPl}.
 * Placeholder "—" w labelPl pomija render tytułu.
 */
export function InstructionBox({ labelPl, helpText }: { labelPl: string; helpText: string | null }) {
  const hasTitle = labelPl && labelPl !== '—'
  return (
    <div className="my-2 rounded-md border border-sky-200 bg-sky-50 px-3 py-2 flex gap-2">
      <Info size={16} className="text-sky-700 mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        {hasTitle && <div className="text-sm font-medium text-sky-900 mb-0.5">{labelPl}</div>}
        <div className="text-sm text-sky-900 whitespace-pre-line">{helpText ?? ''}</div>
      </div>
    </div>
  )
}
